<div id="content">

  @if (stores.order.length >= 1) {
    <div id="select-store">
      Selected Store:
      <app-shared-custom-select
        (selectionChange)="onStoreSelectionChange($event)"
        [allowSelectAll]="false"
        [allowMultiple]="false"
        [autoSubmitOnSelect]="true"
        [placeholder]="'Select Store'"
        [setOptions]="storeSelectOptions()"
        [showActionButtons]="false"
        [showChips]="false"
        [showSearchBar]="false">
      </app-shared-custom-select>
    </div>
  }

  <div id="add">
    <div class="buttons">
      <div id="help-button"
           [ngClass]="{'can-paste': copiedPriceBand?.length > 0, 'can-copy': priceBands[selectedStore]?.length > 0}">
        <span
          (click)="clear()"
          [matTooltip]="help.clearClipboard"
          [ngClass]="{'can-paste': copiedPriceBand?.length > 0}"
          class="mdi mdi-clipboard-off-outline copy-paste">
        </span>
        <span
          (click)="paste()"
          [matTooltip]="help.paste"
          [ngClass]="{'can-paste': copiedPriceBand?.length > 0}"
          class="mdi mdi-content-paste copy-paste">
        </span>
        <span
          (click)="copyAll()"
          [matTooltip]="help.copyAll"
          [ngClass]="{'can-copy': priceBands[selectedStore]?.length > 0}"
          class="mdi mdi-content-copy copy-paste">
        </span>
      </div>

      <button type="button" (click)="addRule()" [disabled]="!selectedStore" mat-icon-button>
        <app-display-icon [icon]="icons.plus"></app-display-icon>
      </button>
    </div>
  </div>

  @for (pb of priceBands[selectedStore]; track $index; let idx = $index) {
    <div class="price-band">
    <div class="range">
      <div class="prop-header">
        <div>
          <div class="text">
            In range:
          </div>
          <app-switch-ui
            [ariaLabel]="'In range'"
            [checked]="!!toggles[selectedStore][idx].range"
            (checkedChange)="toggleRange(pb, idx)">
          </app-switch-ui>
          @if (pb.range) {
            <button
              type="button"
              (click)="hiddenPBs[selectedStore][idx].range = !hiddenPBs[selectedStore][idx].range"
              mat-icon-button>
              <app-display-icon [icon]="hiddenPBs[selectedStore][idx].range ? icons.chevronDown : icons.chevronUp"></app-display-icon>
            </button>
          }
        </div>
        <div>
          <app-display-icon
            class="rule-line-icon"
            (click)="copyRule(pb, idx)"
            [matTooltip]="help.copySingleRule"
            [ngClass]="{copied: selectedStore === copiedStoreId && copiedIdx.includes(idx)}"
            [border]="false"
            [colour]="iconColourEnum.primary"
            [icon]="icons.contentCopy">
          </app-display-icon>
          Rule: {{ idx + 1 }}
          <button type="button" (click)="remove(idx)" mat-icon-button matTooltip="Remove this rule">
            <app-display-icon
              class="close-icon"
              [border]="false"
              [colour]="iconColourEnum.primary"
              [icon]="icons.close">
            </app-display-icon>
          </button>
        </div>
      </div>
      @if (pb.range) {
        <div [hidden]="hiddenPBs[selectedStore][idx].range" class="range-value">
        <span>
          From R
          <input type="text"
            (input)="setRange($event, pb.range, 'start');
             resetRandSnapConstraints(selectedStore, idx)"
            [placeholder]="pb.range.start && pb.range.start.v ? pb.range.start.v : 0"
            [value]="getOgValue('start', idx)"
          >
          <button type="button" (click)="toggleInclusive(pb, 'start')"
                  class="inclusive">{{ pb.range.start && pb.range.start.inc ? 'Inclusive' : 'Exclusive' }}</button>
        </span>
        <span>
          To R<input type="text" (input)="setRange($event, pb.range, 'end'); resetRandSnapConstraints(selectedStore, idx)"
                         [placeholder]="pb.range.end && pb.range.end.v ? pb.range.end.v : null"
                         [value]="getOgValue('end', idx)"
        >
          <button type="button" (click)="toggleInclusive(pb, 'end')"
                  class="inclusive">{{ pb.range.end && pb.range.end.inc ? 'Inclusive' : 'Exclusive' }}</button>
        </span>
      </div>
      }
    </div>
    @if (selectedStore !== '') {
      <div class="departments-filters">
      <div (click)="hiddenPBs[selectedStore][idx].departmentFilters = !hiddenPBs[selectedStore][idx].departmentFilters"
           class="prop-header">
        <div class="text">
          Departments or Sub-Departments
        </div>
        @if (hiddenPBs[selectedStore][idx].departmentFilters) {
          <ng-container>
            <app-display-icon [icon]="icons.chevronDown"></app-display-icon>
            {{ pb.departs || pb.subDeparts ? '*' : '' }}
          </ng-container>
        } @else {
          <ng-template #upTemplate>
            <app-display-icon [icon]="icons.chevronUp"></app-display-icon>
          </ng-template>
        }
      </div>
      <div [hidden]="hiddenPBs[selectedStore][idx].departmentFilters" class="filters">
        <button type="button" (click)="filterDeps($event, pb, 'dep')" mat-raised-button>
          Departments {{ pb.departs ? '(' + pb.departs.length + ')' : '' }}
        </button>
        <button type="button" (click)="filterDeps($event, pb, 'sub')" mat-raised-button>
          Sub-Departments {{ pb.subDeparts ? '(' + pb.subDeparts.length + ')' : '' }}
        </button>
      </div>
    </div>
    }
    <div class="rand-snaps">
      <!--   TODO: NBNBNBNBNBNBNBNBNBNBNBNB
                    I Have to allow multiple, non equal digits. so between 1 and 1000 you can snap AAAAX AAAXX AXXXX XXXX etc
                    counter point from 2 days later... Why?-->
      <div class="prop-header">
        <div>
          <div class="text">
            Rand Snaps:
          </div>
          <app-switch-ui
            [ariaLabel]="'Rand Snaps'"
            [checked]="!!toggles[selectedStore][idx].randSnap"
            (checkedChange)="toggleRandSnaps(pb, idx)">
          </app-switch-ui>
          <!--          (click)="hiddenPBs[selectedStore][idx].randSnaps = !hiddenPBs[selectedStore][idx].randSnaps"-->
          @if (pb.randSnap) {
            <button type="button" (click)="hiddenPBs[selectedStore][idx].randSnaps = !hiddenPBs[selectedStore][idx].randSnaps">
              <app-display-icon [icon]="hiddenPBs[selectedStore][idx].randSnaps ? icons.chevronDown : icons.chevronUp"></app-display-icon>
            </button>
          }
        </div>
        <!--        <button type="button" mat-icon-button *ngIf="!hiddenPBs[selectedStore][idx].randSnaps" (click)="addRandSnap(pb)">-->
        <!--          <app-display-icon [icon]="icons.plus"></app-display-icon>-->
        <!--        </button>-->
      </div>
      @if (pb.randSnap) {
        <div [hidden]="hiddenPBs[selectedStore][idx].randSnaps">
        <div>
          @if (randSnapConstraints[selectedStore][idx]) {
            <ng-container>
              <div class="digit-select">
                Digits to snap:
                <div>
                  <button type="button" (click)="randSnapDigit(1, pb, idx, selectedStore)">
                    <app-display-icon [icon]="icons.chevronLeft"></app-display-icon>
                  </button>
                  <!--              <ng-container *ngTemplateOutlet="selectDecimal; context: {length: 10, decimals: rsMaxSelectableDigits(pb), digit: pb.randSnap.digits}"></ng-container>-->
                  <div class="digit-highlight" matTooltip="Select digits that will be snapped">

                    R&nbsp;
                    @for (_ of [].constructor(randSnapConstraints[selectedStore][idx].digs - pb.randSnap.digits); track $index; ) {
                      <span>0</span>
                    }

                    <span class="high">
                      @for (_ of [].constructor(pb.randSnap.digits); track $index; ) {
                        <ng-container>0</ng-container>
                      }
                    </span>
                    .00
                  </div>
                  <button type="button" (click)="randSnapDigit(-1, pb, idx, selectedStore)">
                    <app-display-icon [icon]="icons.chevronRight"></app-display-icon>
                  </button>
                </div>
                @if (!hiddenPBs[selectedStore][idx].centSnaps) {
                  <button
                    type="button"
                    (click)="addRandSnap(idx)"
                    mat-icon-button
                    matTooltip="Add rand digits snap">
                    <app-display-icon [icon]="icons.plus"></app-display-icon>
                  </button>
                }
              </div>
              <div class="list">
                @for (rSnap of pb.randSnap.snaps; track $index; let snapIdx = $index) {
                  <div>
                  <div class="range-value">
                    <span>
                      <button type="button" (click)="remove(idx, snapIdx, 'rand')" class="smol-butt" matTooltip="Remove this snap"
                              matTooltipPosition="after">
                        <app-display-icon [icon]="icons.close"></app-display-icon>
                      </button>
                      {{ randSnapsIDs[snapIdx] }}:
                    </span>
                    <span>
                      From
                      <input type="text" (input)="setRange($event, rSnap.range, 'start', 'rand', pb.randSnap.digits)"
                                 [placeholder]="pb.randSnap.snaps[snapIdx].range.start.v && pb.randSnap.snaps[snapIdx].range.start ? pb.randSnap.snaps[snapIdx].range.start.v : 0"
                                 [value]="getOgValue('start', idx, snapIdx, 'rand')"
                      >
                      <button type="button" (click)="toggleInclusive(rSnap, 'start')"
                              class="inclusive">{{ rSnap.range.start && rSnap.range.start.inc ? 'Inclusive' : 'Exclusive' }}</button>
                    </span>
                    <span>
                      To
                      <input type="text" (input)="setRange($event, rSnap.range, 'end', 'rand', pb.randSnap.digits)"
                                 [placeholder]="pb.randSnap.snaps[snapIdx].range.end.v && pb.randSnap.snaps[snapIdx].range.end ? pb.randSnap.snaps[snapIdx].range.end.v : null"
                                 [value]="getOgValue('end', idx, snapIdx, 'rand')"
>
                      <button type="button" (click)="toggleInclusive(rSnap, 'end')"
                              class="inclusive">{{ rSnap.range.end && rSnap.range.end.inc ? 'Inclusive' : 'Exclusive' }}</button>
                    </span>
                  </div>
                  <div class="snap-to-container">
                    <span>
                      Snap To
                      <input type="text" (input)="setSnapValue($event, pb, snapIdx, 'rand')"
                                 [placeholder]="pb.randSnap.snaps[snapIdx].v && pb.randSnap.snaps[snapIdx] ? pb.randSnap.snaps[snapIdx].v: null"
                                 [value]="getOgValue('snap', idx, snapIdx, 'rand')"
>
                      @if (pb.randSnap.snaps.length > 1) {
                        <span class="shift-controls">
                          @if (snapIdx !== 0) {
                            <button type="button" (click)="shiftSnap(idx, snapIdx, 'rand', -1)" class="smol-butt"
                                    matTooltip="Move this snap up"
                                    matTooltipPosition="before">
                              <app-display-icon [icon]="icons.chevronUp"></app-display-icon>
                            </button>
                          }
                        @if (snapIdx !== pb.randSnap.snaps.length - 1) {
                          <button type="button" (click)="shiftSnap(idx, snapIdx, 'rand', 1)"
                                  class="smol-butt" matTooltip="Move this snap down"
                                  matTooltipPosition="before">
                            <app-display-icon [icon]="icons.chevronDown"></app-display-icon>
                          </button>
                        }
                      </span>
                      }
                    </span>
                  </div>
                </div>
                }
              </div>
            </ng-container>
          } @else {
            <ng-template #notAllowedRSTemplate>
              <div class="range-too-small orange-msg">
                <p>This price band range is too low to support Rand Snaps</p>
              </div>
            </ng-template>
          }
        </div>
      </div>
      }
    </div>
    <div class="cent-snaps">
      <div class="prop-header">
        <div (click)="hiddenPBs[selectedStore][idx].centSnaps = !hiddenPBs[selectedStore][idx].centSnaps">
          <div class="text">
            Cent Snaps:
          </div>
          @if (hiddenPBs[selectedStore][idx].centSnaps) {
            <ng-container>
              <app-display-icon [icon]="icons.chevronDown"></app-display-icon>
              {{ pb.centSnaps ? '*' : '' }}
            </ng-container>
          } @else {
            <ng-template #upTemplate>
              <app-display-icon [icon]="icons.chevronUp"></app-display-icon>
            </ng-template>
          }
        </div>
        @if (!hiddenPBs[selectedStore][idx].centSnaps) {
          <button type="button" (click)="addCentSnap(idx)" mat-icon-button>
            <app-display-icon [icon]="icons.plus"></app-display-icon>
          </button>
        }
      </div>
      @if (pb.centSnaps) {
        <div [hidden]="hiddenPBs[selectedStore][idx].centSnaps" class="list">
          @for (cSnap of pb.centSnaps; track $index; let snapIdx = $index) {
            <div>
          <div class="range-value">
            <span>
              <button type="button" (click)="remove(idx, snapIdx, 'cents')" class="smol-butt" matTooltip="Remove this snap"
                      matTooltipPosition="after">
                <app-display-icon [icon]="icons.close"></app-display-icon>
              </button>
              {{ centSnapsIDs[snapIdx] }}:
            </span>
            <span>
              From
              <input type="text" (input)="setRange($event, cSnap.range, 'start', 'cents')"
                         [placeholder]="pb.centSnaps[snapIdx].range.start.v && pb.centSnaps[snapIdx].range.start ? pb.centSnaps[snapIdx].range.start.v : 0"
                         [value]="getOgValue('start', idx, snapIdx)"
              > cents
              <button type="button" (click)="toggleInclusive(cSnap, 'start')"
                      class="inclusive">{{ cSnap.range.start && cSnap.range.start.inc ? 'Inclusive' : 'Exclusive' }}</button>
            </span>
            <span>
              To
              <input type="text" (input)="setRange($event, cSnap.range, 'end', 'cents')"
                         [placeholder]="pb.centSnaps[snapIdx].range.end.v && pb.centSnaps[snapIdx].range.end ? pb.centSnaps[snapIdx].range.end.v : null"
                         [value]="getOgValue('end', idx, snapIdx)"
              > cents
              <button type="button" (click)="toggleInclusive(cSnap, 'end')"
                      class="inclusive">{{ cSnap.range.end && cSnap.range.end.inc ? 'Inclusive' : 'Exclusive' }}</button>
            </span>
          </div>
          <div class="snap-to-container">
            <span>
              Snap To
              <input type="text" (input)="setSnapValue($event, pb, snapIdx)" [placeholder]="pb.centSnaps[snapIdx].v && pb.centSnaps[snapIdx]? pb.centSnaps[snapIdx].v : null"
                         [value]="getOgValue('snap', idx, snapIdx)"
> cents
                   @if (pb.centSnaps.length > 1) {
                <span class="shift-controls">
                  @if (snapIdx !== 0) {
                    <button type="button" (click)="shiftSnap(idx, snapIdx, 'cents', -1)" class="smol-butt"
                            matTooltip="Move this snap up"
                            matTooltipPosition="before">
                      <app-display-icon [icon]="icons.chevronUp"></app-display-icon>
                    </button>
                  }
                  @if (snapIdx !== pb.centSnaps.length - 1) {
                    <button type="button" (click)="shiftSnap(idx, snapIdx, 'cents', 1)" class="smol-butt"
                            matTooltip="Move this snap down"
                            matTooltipPosition="before">
                      <app-display-icon [icon]="icons.chevronDown"></app-display-icon>
                    </button>
                  }
              </span>
               }
            </span>
          </div>
        </div>
          }
        </div>
      }
    </div>
    </div>
  }
  <div id="save-button">
    <button type="button" (click)="check4save()" mat-raised-button>validate</button>
  </div>
</div>
